// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { OperatorConfiguration } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Configuration/Operator';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';

const useRegistryOperatorConfigurations: () => UseQueryResult<
  TemplateContract<OperatorConfiguration>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  return useQueryWithOptions({
    queryKey: ['queryRegistryOperatorConfigurations', operator],
    enabled: !!operator,
    queryFn: async (_, options) => {
      return ledgerApi.queryRegistryOperatorConfigurations(options, operator);
    },
  });
};

export default useRegistryOperatorConfigurations;
